// extracted by mini-css-extract-plugin
module.exports = {"DialogContent":"📚4-7-02foFf"};